import { render } from "./PaymentSuccessFailed.vue?vue&type=template&id=6311687d&lang=pug"
import script from "./PaymentSuccessFailed.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessFailed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__